module.exports = __webpack_public_path__ + "static/media/instructivooc2.0b976526.png";